import { format, isValid } from "date-fns";

import type { ProcessingEvent } from "services/types/processing-event.type";

/** Must match the number of columns in `ProcessingEventsTimeline` table header. */
export const PROCESSING_EVENTS_TABLE_COLUMN_COUNT = 5;

const EVENT_TYPE_COLOR: Record<
  ProcessingEvent["event_type"],
  "success" | "error" | "default"
> = {
  succeeded: "success",
  failed: "error",
  started: "default",
  skipped: "default",
  closed: "default"
};

export function getEventTypeChipColor(
  eventType: string
): "success" | "error" | "default" {
  if (eventType in EVENT_TYPE_COLOR) {
    return EVENT_TYPE_COLOR[eventType as ProcessingEvent["event_type"]];
  }
  return "default";
}

export function formatCreatedAt(
  createdAt: string | number | null | undefined
): string {
  if (createdAt == null || createdAt === "") {
    return "—";
  }
  const date = new Date(createdAt);
  return isValid(date) ? format(date, "MM/dd HH:mm:ss") : "—";
}

export function fieldLabelFromKey(key: string): string {
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDetailValue(value: unknown): string {
  if (value == null) {
    return "—";
  }
  if (value === "") {
    return "—";
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return "[Unable to display metadata]";
    }
  }
  return String(value);
}

export function sortedEventDetailKeys(
  event: ProcessingEvent
): (keyof ProcessingEvent)[] {
  return (Object.keys(event) as (keyof ProcessingEvent)[]).sort((a, b) =>
    String(a).localeCompare(String(b))
  );
}

export function isJsonLikeValue(value: unknown): boolean {
  return typeof value === "object" && value != null;
}
